import { render } from "./WalletActity.vue?vue&type=template&id=e2c4583c&scoped=true"
import script from "./WalletActity.vue?vue&type=script&lang=js"
export * from "./WalletActity.vue?vue&type=script&lang=js"

import "./WalletActity.vue?vue&type=style&index=0&id=e2c4583c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c4583c"]])

export default __exports__